module.exports = __webpack_public_path__ + "img/coupons2.ea9585de.jpg";